import { environment } from '../../environments/environment';

export const BACKEND_PATHS = {
  ESTIMATIONS: environment.backend.url + '/estimations',
  NOTIFICATIONS: environment.backend.url + '/notifications',
  MONITORING: environment.backend.url + '/monitorings',
  AZURE: environment.backend.url + '/azure',
  FEEDBACK: environment.backend.url + '/feedback',
};
